/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import { dataService } from '../../../../../services/data.services';
import FeeStructureDropdown from '../../../../../components/FeeStructureDropdown';

const AcademicDetails = ({
    selectedObjects, 
    setSelectedObjects,
    setSelectedDropDownValue,
    submitSelected,
    academicYears,
    setsubmitSelected,
    classes,
    setSectionName,
    optionalSubjects,
    branch_id,
    branch_name, 
    studentAcademicDetails,
    selectedSections,
    mandatorySubjects,
    setMandatorySubjects,
    setSelectedSections,
    setAcademicDidDropDownChange,
    setOptionalSubjects,
    edit,
    sectionsLoading,
    setSectionsLoading,
    didDropDownChange,
    hasStartDateBegun,
    setStudentAcademicDetails}) => {

    /* The above code is using the useEffect hook in React to perform some actions when the
    dependencies `studentAcademicDetails.academic_year` or `studentAcademicDetails.classes` change. */
    useEffect(() => {
        if(studentAcademicDetails?.academic_year?.name!=""&&studentAcademicDetails?.classes?.class_name!=""){
            callSectionAPI()
            setSectionsLoading(true)
            setSectionName(studentAcademicDetails?.sections?.section_name)
        }
    }, [studentAcademicDetails?.academic_year,studentAcademicDetails?.classes]);
    
    setSectionName(studentAcademicDetails?.sections?.section_name)

    /**
     * The function `handleOnchangeInput` is used to handle the onchange event of an input element and
     * update the state variables accordingly.
     */
    const handleOnchangeInput = (id, option) => {
        setAcademicDidDropDownChange(true)
        setStudentAcademicDetails(prev => {
            const { fee_term_id, ...rest } = prev;
            return rest;
        });
        setsubmitSelected(false);
        if(id === "academic_year") {
            setSectionName('')
            setOptionalSubjects([])
            setMandatorySubjects([])
            setSelectedObjects([])
            setStudentAcademicDetails((prv) => ({
                ...prv,
                "academic_year": {
                    "name": option.name,
                    "start_date": option.start_date,
                    "end_date": option.end_date,
                    "academic_year_id" : option._id,
                },
                "classes":{
                    "class_name": "",
                    "class_id": ""
                },
                "sections":{
                    "section_name": "",
                    "section_id": ""
                },
                "mandatory_subject": [
                    {
                        "subject_id": "",
                        "subject_name": ""
                    }
                ]
                
            }));
        } else if(id==="class_name"){
            setSectionName('')
            setOptionalSubjects([])
            setMandatorySubjects([])
            setSelectedObjects([])
            setStudentAcademicDetails((prv) => ({
                ...prv,
                "classes":{
                    "class_name": option.name,
                    "class_id": option._id
                },
                "sections":{
                    "section_name": "",
                    "section_id": ""
                },
            }));
        }
        else if(id==="section"){
            setSelectedObjects([])
            setStudentAcademicDetails((prv)=>({
                ...prv,
                "sections":{
                    "section_name":option.name,
                    "section_id":option.id
                }
            }))
        }
        
    }

    
    /**
     * The function `callSectionAPI` makes an API call to retrieve sections based on the academic year
     * and class name, and then updates the selected sections state with the response data.
     */
    const callSectionAPI=async()=>{
        if(studentAcademicDetails?.academic_year?.academic_year_id!==undefined&&studentAcademicDetails?.classes?.class_id!==undefined)
        {
            let endpoint = `associations?branch_id=${branch_id}&academic_year_id=${studentAcademicDetails?.academic_year?.academic_year_id}&class_id=${studentAcademicDetails?.classes?.class_id}&filter=true&role=directory`;
            const response = await dataService.GetAPI(endpoint, true);
            const temp = response.data?.data?.data;
            setSelectedSections(temp.map(obj=>{
                return{
                    "name":obj.section_name,
                    "id":obj.section_id,
                    "subjects":obj.subjects
                }}))
            
            setSectionsLoading(false);
        }
    
    }
 
    /**
     * The function `handleCheckboxChange` toggles the selection of an object based on its ID and
     * updates the `selectedObjects` array accordingly.
     */
    const handleCheckboxChange = (id, item) => {
        setSelectedDropDownValue('')
        setAcademicDidDropDownChange(true)
        setStudentAcademicDetails(prev => {
            const { fee_term_id, ...rest } = prev;
            return rest;
        });
        const index = selectedObjects.findIndex(obj => obj.subject_id === id);
    
        if (index !== -1) {
            setSelectedObjects(prevSelected => prevSelected.filter(obj => obj.subject_id !== id));
        } else {
            const selectedObject = { "subject_id": item.subject_id,
                "subject_name": item.subject_name,
                "amount": item?.amount === undefined ? "" : item?.amount.toString()};
            setSelectedObjects(prevSelected => [...prevSelected, selectedObject]);
        }
    };
    return (
        <div class="border border-[#D0D5DD] p-3 rounded acadamic_details_section mb-8">
            <div class="flex">
                <div class="w-[480px] pr-6">
                    <p class="text-f7 font-semibold text-[#031624] pb-3">{studentAcademicDetails?.academic_year?.name === ""?"Admitted to":"Current AY Details"}</p>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Branch Name</label>
                        <p title={branch_name} class="w-full more-lines text-f7 font-semibold text-[#031624]">{branch_name}</p>
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Academic Year<span class="req-fld-astrk">*</span></label>
                        <FeeStructureDropdown
                            dropDownName={"academic_year"}
                            id = {"name"}
                            test_id = {"year_name"}
                            value={studentAcademicDetails?.academic_year?.name === "" ? ""  : `${studentAcademicDetails?.academic_year?.name}`}
                            placeHolder={"Select Year"}
                            buttonDisabled={academicYears?.length === 0 || edit && hasStartDateBegun && !didDropDownChange || edit && studentAcademicDetails?.has_invoice}
                            showErrorBorder={submitSelected && studentAcademicDetails?.academic_year?.name === ""}
                            applyBGForDisabled={true}
                            isMandatoryField={true}
                            options={academicYears}
                            handleOnchangeInput={handleOnchangeInput}/>
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Class<span class="req-fld-astrk">*</span></label>
                        <FeeStructureDropdown
                            dropDownName={"class_name"}
                            value={studentAcademicDetails?.classes?.class_name}
                            divClassName={"relative w-full"}
                            buttonDisabled={classes?.length === 0 || edit && hasStartDateBegun && !didDropDownChange || edit && studentAcademicDetails?.has_invoice}
                            applyBGForDisabled={true}
                            placeHolder={"Select Class"}
                            showErrorBorder={submitSelected && studentAcademicDetails?.classes?.class_name === ""}
                            isMandatoryField={true}
                            options={classes}
                            handleOnchangeInput={handleOnchangeInput}
                            toottip={false}
                        />
                        
                    </div>
                    <div class="flex items-center w-full">
                        <label class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Section<span class="req-fld-astrk">*</span></label>
                        <FeeStructureDropdown
                            dropDownName={"section"}
                            value={studentAcademicDetails?.sections?.section_name}
                            divClassName={"relative w-full"}
                            buttonDisabled={studentAcademicDetails?.academic_year?.name === "" || studentAcademicDetails?.classes?.class_name === "" || edit && hasStartDateBegun && !didDropDownChange || edit && studentAcademicDetails?.has_invoice}
                            placeHolder={"Select Section"}
                            applyBGForDisabled={true}
                            showErrorBorder={submitSelected && studentAcademicDetails?.sections?.section_name === ""}
                            isMandatoryField={true}
                            options={selectedSections}
                            handleOnchangeInput={handleOnchangeInput}
                            toottip={false}
                            loading={sectionsLoading}
                        />
                    </div>
                </div>
                <div class="border-l border-[#D0D5DD]">
                    <div class="flex h-full">
                        <div class="w-[267px] px-4">
                            <p class="text-f7 font-semibold text-[#031624] flex justify-start">Mandatory Subjects</p>
                            <ul class="mt-[18px] pl-[10px]  overflow-auto  break-all">
                                {
                                    mandatorySubjects.map((subject)=>(
                                        <li key={subject.subject_id} className='text-f7 font-normal text-[#031624] mb-4'>
                                            {subject?.subject_name}
                                        </li>       
                                    ))
                                    
                                }
                            </ul>
                        </div>
                        <div class="w-[245px] pl-4 border-l border-[#D0D5DD]">
                            <p class="text-f7 font-semibold text-[#031624] flex justify-start">Optional Subjects</p>
                            <ul class="pl-[10px] mt-[18px]  overflow-auto break-all">
                                {optionalSubjects?.map((item)=>(
                                    <li key={item.subject_id}>
                                        <div class={`relative checkbox ${hasStartDateBegun ? 'custom-checkBoxBlueBranch1Disabled' : 'custom-checkBoxBlueBranch1'} mb-4 flex`}>
                                            <input 
                                                type="checkbox" 
                                                checked={selectedObjects.some(selectedObj => selectedObj.subject_id === item.subject_id)}
                                                id={item.subject_id} 
                                                disabled={hasStartDateBegun}
                                                onChange={() => handleCheckboxChange(item.subject_id, item)}
                                            />
                                            <label
                                                htmlFor={item.subject_id}
                                                className={`text-f2 font-normal text-[#031624] pl-3 w-full ${!hasStartDateBegun && 'cursor-pointer'}`}
                                                title={`${item.subject_name}${item.amount !== undefined && item.amount !== '' ? `(${parseFloat(item.amount).toFixed(2)})` : ''}`}
                                            >
                                                {item.subject_name}
                                                {(item.amount !== undefined && item.amount !== '') ? `(${parseFloat(item.amount).toFixed(2)})` : ''}
                                            </label>                                            
                                            {/* <label for={item.subject_id} class="text-f2 font-normal text-[#031624] pl-3 w-full cursor-pointer more-lines" title={`${item.name_sort}${item.amount !== undefined ? `(${item.amount})` : ''}`}>{item.name_sort}{item.amount !== undefined && `(${item.amount})`}</label> */}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AcademicDetails